import React from "react";
import { createSolarReport } from "../../../util/operations/solar";
import EnterRoofAdress from "../../solar-steps-components/RoofAddress";
import OwnHome from "../../solar-steps-components/OwnHome";
import AverageElecticityBill from "../../solar-steps-components/AvgElectBillSlider";
import QuoteOwner from "../../solar-steps-components/QuoteOwnerName";
import QuoteOwnerPhoneNumber from "../../solar-steps-components/QuoteOwnerPhoneNumber";
import QuoteOwnerEmail from "../../solar-steps-components/QuoteOwnerEmail";
import ReportLoading from "../../solar-steps-components/ReportLoading";
import PageLoader from "../../PageLoader";

// import addReferral from "../../../util/operations/referral";

export const renderRequiredStep = (
  step,
  setStep,
  roofData,
  setRoofData,
  handleGenerateReport,
  userAddress,
  errorMessage,
  setErrorMessage,
  refCode
) => {
  switch (step) {
    case 0:
      return (
        <EnterRoofAdress
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
          userAddress={userAddress}
          refCode={refCode}
        />
      );
    case 1:
      return (
        <OwnHome
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );
    case 2:
      return (
        <AverageElecticityBill
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );

    case 3:
      return (
        <QuoteOwner
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );

    case 4:
      return (
        <QuoteOwnerPhoneNumber
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );
    case 5:
      return (
        <QuoteOwnerEmail
          setStep={setStep}
          roofData={roofData}
          setRoofData={setRoofData}
        />
      );
    case 6:
      return (
        <ReportLoading
          setStep={setStep}
          roofData={roofData}
          handleGenerateReport={handleGenerateReport}
          userAddress={userAddress}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          refCode={refCode}
        />
      );

    default:
      return <PageLoader />;
  }
};

export const handleGenerateReport = async (
  roofData,
  userAddress,
  setErrorMessage,
  refCode,
  setLoading
) => {
  setLoading(true);
  const { electricityBill, email, houseOwner, ownerName, phone } = roofData;

  const solarRoofData = {
    fullname: ownerName,
    email,
    phoneNumber: phone,
    fullAddress: userAddress,
    monthlyBill: electricityBill,
  };

  const response = await createSolarReport(solarRoofData);

  if (response && response.status) {
    const {
      data: { id },
    } = response;

    return setLoading(false);
  }

  setLoading(false);
  return setErrorMessage("error");
};
